"use strict"
exports.__esModule = true;
exports.GenderlessIconConfig = {
  name: 'GenderlessIcon',
  height: 512,
  width: 288,
  svgPath: 'M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z',
  yOffset: 0,
  xOffset: 0,
};
exports.GenderlessIcon = require('../createIcon').createIcon(exports.GenderlessIconConfig);
exports["default"] = exports.GenderlessIcon;